// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/illustration-template/src/index.tsx

import baseIllustration from '@bubble-ui/temp-illustration-base';
var IllustrationSecurityPath = 'M70.792 43.564V28.723C70.792 17.24 61.483 7.93 50 7.93c-11.483 0-20.792 9.309-20.792 20.792v14.841h6.93V28.861C36.139 21.206 42.346 15 50 15s13.861 6.206 13.861 13.861v14.703h6.931zm-13.861 0V28.861a6.93 6.93 0 00-13.862 0v14.703h13.862zm-34.654 0V28.723C22.277 13.412 34.69 1 50 1c15.31 0 27.723 12.412 27.723 27.723v14.841h8.91v34.258a10.396 10.396 0 01-2.178 6.336l-8.91 11.783A10.496 10.496 0 0167.227 100H32.772a10.496 10.496 0 01-8.317-4.06l-8.91-11.782a10.397 10.397 0 01-2.179-6.336V43.564h8.911zm33.664 22.877a5.933 5.933 0 01-2.476 4.825v10.026h-6.93V71.266a5.94 5.94 0 119.406-4.826zM20.297 50.495v27.327c.02.746.26 1.47.693 2.079L30 91.683a3.367 3.367 0 002.772 1.386h34.456A3.367 3.367 0 0070 91.683l9.01-11.782a3.762 3.762 0 00.693-2.08V50.496H20.297z';
var IllustrationSecurity = baseIllustration('IllustrationSecurity', {
  getPath: () => IllustrationSecurityPath
}, 'ColoredIllustrationSecurity');

/**
 * @deprecated this component is outdated and will be removed with v6.0.0
 */
export default IllustrationSecurity;
//# sourceMappingURL=index.js.map